import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { EulaService } from '../../../services/eula.service';
import { KeyHandlerDirective } from '../../../directives/key-handler.directive';

@Component({
    selector: 'lex-eula-dialog',
    templateUrl: './eula-dialog.component.html',
    styleUrls: ['./eula-dialog.component.scss'],
    standalone: false
})
export class EulaDialogComponent extends KeyHandlerDirective implements OnInit {

  eulaContent$: Observable<SafeHtml>;
  loading = true;
  agreeChecked = false;

  constructor(private eulaService: EulaService, private dialogRef: MatDialogRef<EulaDialogComponent>) {
    super();
  }

  ngOnInit() {
    this.eulaContent$ = this.eulaService.getEula().pipe(tap(() => this.loading = false));
  }

  ok(): void {
    this.eulaService.signEula()
      .subscribe(
        response => this.dialogRef.close(response),
        () => this.dialogRef.close(false)
      );
  }
}
